<template>
  <div class="contain">
    <!-- 검색 조건 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="{ tablet: 'top' }[$device.currentSize] ?? 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :sm="8">
            <el-form-item :label="$t('키워드')">
              <el-input v-model="searchForm.nm" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('단말 타입')">
              <code-combo
                :data="clientTp"
                :label="$t('전체')"
                :model="searchForm.clientTpCd"
                @change="searchForm.clientTpCd = $event.cd"></code-combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼-->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('LanDataSearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('LanDataAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('LanDataUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button v-if="checkAuthActionAccess('LanDataDown')" :size="size" @click="downExcel" icon="el-icon-download">{{
        $t('출력')
      }}</el-button>

      <el-upload
        v-if="checkAuthActionAccess('LanDataDown')"
        :show-file-list="false"
        :action="`${APP_API_URL}/lanData/up`"
        accept="application/vnd.ms-excel"
        :headers="uploadHeaders"
        style="display: inline; margin-left: 10px"
        with-credentials
        :on-success="upSuccess"
        :on-error="upError">
        <el-button :size="size" icon="el-icon-upload">{{ $t('업로드') }}</el-button>
      </el-upload>

      <el-button
        v-if="checkAuthActionAccess('LanDataAdd') || checkAuthActionAccess('LanDataUp')"
        :size="size"
        @click="save"
        icon="el-icon-check"
        :disabled="btn.saveDisabled"
        style="float: right"
        class="hide-on-mobile"
        >{{ $t('저장') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-row :gutter="20">
      <el-col :md="16">
        <div id="out-table">
          <el-table
            :height="tableHeight"
            ref="table"
            border
            stripe
            highlight-current-row
            tooltip-effect="dark"
            :data="tableData"
            :size="size"
            :empty-text="$t('데이타 없음')"
            @row-click="handleRowClick">
            <el-table-column
              :label="tableData.length.toString()"
              type="index"
              width="55"
              align="center"
              label-class-name="data_cnt"></el-table-column>
            <el-table-column
              :label="$t('언어 코드')"
              prop="id"
              min-width="200"
              sortable
              show-overflow-tooltip></el-table-column>
            <el-table-column
              :label="$t('단말 타입')"
              prop="clientTp.nmLan"
              min-width="120"
              align="center"
              sortable
              show-overflow-tooltip></el-table-column>
            <el-table-column
              v-for="item in lans"
              :key="item.id"
              :label="item.nm"
              :prop="item.id"
              min-width="200"
              sortable
              show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :md="8">
        <el-card shadow="never" :style="{ height: inputHeight + 'px' }" class="input-menu">
          <div slot="header">
            <span>{{ $t('언어') }}</span>
            <span v-if="'I' == inputForm.statu">{{ $t('추가') }}</span>
            <span v-if="'U' == inputForm.statu">{{ $t('수정') }}</span>
          </div>
          <div>
            <el-form
              :model="inputForm"
              :label-width="$device.mobile ? `` : `120px`"
              label-suffix=":"
              :size="size"
              :disabled="fromDisabled"
              @submit.native.prevent>
              <el-form-item :label="$t('언어 코드')" :error="formError.id" required>
                <el-input
                  v-model="inputForm.id"
                  maxlength="250"
                  show-word-limit
                  clearable
                  v-if="'I' === inputForm.statu"></el-input>
                <span v-else class="show_cd">{{ inputForm.id }}</span>
              </el-form-item>
              <el-form-item :label="$t('단말 타입')" :error="formError['clientTp.cd']" required>
                <code-combo
                  :data="clientTp"
                  :model="inputForm.clientTp"
                  @change="inputForm.clientTp = $event"></code-combo>
              </el-form-item>
              <el-form-item :label="$t('한국어')" :error="formError.nm" required>
                <el-input v-model="inputForm.nm" type="textarea" maxlength="250" show-word-limit></el-input>
              </el-form-item>
              <el-form-item :key="item.lan.nm" v-for="item in inputForm.lanDatas" :label="item.lan.nm">
                <el-input v-model="item.nm" type="textarea" maxlength="250" show-word-limit></el-input>
              </el-form-item>
            </el-form>

            <el-button
              v-if="checkAuthActionAccess('LanDataAdd') || checkAuthActionAccess('LanDataUp')"
              :size="size"
              @click="save"
              icon="el-icon-check"
              :disabled="btn.saveDisabled"
              style="float: right"
              class="hide-on-desktop"
              >{{ $t('저장') }}</el-button
            >
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'
import { downloadExcelFile } from '@/utils/downloadExcelFile'
import { mapGetters } from 'vuex'

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()

    data.url = '/lanData'

    data.lans = []
    data.clientTp = []

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    return data
  },
  computed: {
    // 직접 업로드(`el-upload`)가 싣는 CSRF 헤더 — 스토어가 지금 토큰에서 셈한다(서버가 받는 이름 한 곳)
    ...mapGetters({ uploadHeaders: 'auth/csrfHeaders' }),
  },
  created: function () {
    this.initLan()
    this.initClientTp()
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            // this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      1000
    )
  },
  watch: {
    'inputForm.id': function (newVal, oldVal) {
      if ('' != newVal && 'I' === this.inputForm.statu) {
        this.chkLanDataId()
      }
    },
    'inputForm.clientTp.cd': function (newVal, oldVal) {
      for (var i = 0, len = this.inputForm.lanDatas.length; i < len; i++) {
        this.inputForm.lanDatas[i].clientTp.cd = newVal
      }
    },
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        nm: '',
        clientTpCd: 0,
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      var obj = {
        statu: 'I',
        cd: 0,
        id: '',
        nm: '',
        useYn: 'Y',
        lan: null,
        clientTp: { cd: null, nm: '' },
        lanDatas: [],
      }

      if (null != this.lans) {
        // 기타 언어 변수 설정
        for (var i = 0, len = this.lans.length; i < len; i++) {
          if ('ko' == this.lans[i].id) {
            obj.lan = this.lans[i]
          } else {
            obj.lanDatas.push({
              cd: 0,
              id: '',
              nm: '',
              useYn: 'Y',
              lan: this.lans[i],
              clientTp: { cd: null, nm: '' },
            })
          }
        }
      }

      return obj
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        id: '',
        nm: '',
        'clientTp.cd': '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 언어 데이타 조회
    async initLan() {
      const result = await this.$axios.get('/language').then((res) => res.data)
      this.lans = result
    },
    // 단말 타입 데이타 조회
    async initClientTp() {
      const result = await this.$axios.get('/code/getCode/CLIENT_TP').then((res) => res.data)

      this.clientTp = result
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      // 단말 타입 처음 항목 설정
      this.inputForm.clientTp = this.clientTp.length > 0 ? util.copyObj(this.clientTp[0]) : { cd: null, nm: '' }
      for (var i = 0, len = this.inputForm.lanDatas.length; i < len; i++) {
        this.inputForm.lanDatas[i].clientTp =
          this.clientTp.length > 0 ? util.copyObj(this.clientTp[0]) : { cd: null, nm: '' }
      }

      this.formError = this.initFormError()

      this.btn.saveDisabled = false
      this.fromDisabled = false
    },
    // 수정
    up: async function () {
      const result = await this.$axios.get(this.url + '/' + this.selectData.cd).then((res) => res.data)

      console.log('from Server')
      console.log(result)

      result.statu = 'U'

      this.inputForm = result

      // 수정 시 등록되지 안은 기타 언어 변수 설정
      for (var i = 0, len = this.lans.length; i < len; i++) {
        if ('ko' != this.lans[i].id) {
          var isContains = false

          for (var j = 0, jlen = this.inputForm.lanDatas.length; j < jlen; j++) {
            if (this.inputForm.lanDatas[j].lan.id === this.lans[i].id) {
              isContains = true
            }
          }

          if (!isContains) {
            this.inputForm.lanDatas.push({
              cd: 0,
              id: this.inputForm.id,
              nm: this.inputForm.id,
              useYn: 'Y',
              lan: this.lans[i],
              clientTp: this.inputForm.clientTp,
            })
          }
        }
      }

      console.log('inputForm.lanDatas')
      console.log(this.inputForm.lanDatas)

      this.formError = this.initFormError()

      this.btn.saveDisabled = false
      this.fromDisabled = false
    },
    // 조회
    search: async function () {
      const result = await this.$axios.get(this.url, { params: this.searchForm }).then((res) => res.data)

      this.tableData = []

      for (var i = 0, len = result.length; i < len; i++) {
        var tmp = result[i]

        tmp[result[i].lan.id] = result[i].nm

        for (var j = 0, jlen = result[i].lanDatas.length; j < jlen; j++) {
          tmp[result[i].lanDatas[j].lan.id] = result[i].lanDatas[j].nm
        }

        this.tableData.push(tmp)
      }

      this.btn.addDisabled = false
      this.btn.upDisabled = true
      this.btn.saveDisabled = true
      this.fromDisabled = true

      this.inputForm = this.initInputForm()
      this.formError = this.initFormError()
    },
    // 저장
    save: async function () {
      this.formError = this.initFormError()

      var tmpInput = {
        cd: this.inputForm.cd,
        id: this.inputForm.id,
        nm: this.inputForm.nm,
        useYn: this.inputForm.useYn,
        lan: this.inputForm.lan,
        clientTp: this.inputForm.clientTp,
        lanDatas: [],
      }

      // 입력되지 안은 언어 삭제
      for (var i = 0, len = this.inputForm.lanDatas.length; i < len; i++) {
        if ('' != this.inputForm.lanDatas[i].nm) {
          // 언어 코드 기타 언어에도 똑같이 설정
          this.inputForm.lanDatas[i].id = this.inputForm.id
          this.inputForm.lanDatas[i].clientTp = this.inputForm.clientTp
          tmpInput.lanDatas[tmpInput.lanDatas.length] = this.inputForm.lanDatas[i]
        }
      }

      if ('I' === this.inputForm.statu) {
        try {
          await this.$axios.post(this.url, tmpInput)

          this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
          this.search()
        } catch (error) {
          this.formError
        }
      } else {
        try {
          console.log(tmpInput)
          await this.$axios.put(this.url + '/' + this.inputForm.cd, tmpInput)

          this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
          this.search()
        } catch (error) {
          this.formError
        }
      }
    },
    chkLanDataId: async function () {
      // 서버에서 한국어 기준으로 체크 함
      // @TODO without loading
      const result = await this.$axios.patch(this.url + '/chk/' + encodeURI(this.inputForm.id), {
        showLoading: false,
      })

      console.log(result)
      if (!result.data) {
        this.formError.id = ''
        this.btn.saveDisabled = false
      } else {
        this.formError.id = this.$t('이미 사용중인 언어 코드입니다.')
        this.btn.saveDisabled = true
      }
    },
    downExcel: function () {
      const url = this.url + '/down?nm=' + this.searchForm.nm

      downloadExcelFile(url)
    },
    upSuccess: function () {
      this.mainVue.$message({ type: 'success', message: this.$t('업로드 되었습니다') })
      this.search()
    },
    upError: function () {
      this.mainVue.$message({ type: 'error', message: this.$t('업로드 실패 하였습니다') })
    },
  },
}
</script>
